import React, { useContext } from 'react';
import Text from 'components/Text';
import { LocaleContext } from 'containers/LocaleContext';
const Loading = (props) => {
    const { state } = props;
    const { I18n } = useContext(LocaleContext);
    return (React.createElement("div", { className: "full-screen-loader", "data-testid": "full-screen-loader" },
        React.createElement("img", { src: require('assets/svgs/spinner.svg'), alt: "Loading", style: { width: 150, height: 150, marginBottom: 40 } }),
        state === 'GENERATING' && React.createElement(Text.Base, { centered: true }, I18n.t('search.generating')),
        state === 'SEARCHING' && React.createElement(Text.Base, { centered: true }, I18n.t('search.searching'))));
};
export default Loading;
